const component = {
  template: `
  <div class="socialMedia">
    <div class="socialMedia__text" ng-bind-html="$ctrl.text"></div>
    <ul class="socialMedia__links">
      <li class="socialMedia__facebook socialMedia__icon" ng-if="$ctrl.facebook"><a href="{{$ctrl.facebook}}"></a></li>
      <li class="socialMedia__instagram socialMedia__icon" ng-if="$ctrl.instagram"><a href="{{$ctrl.instagram}}"></a></li>
      <li class="socialMedia__twitter socialMedia__icon" ng-if="$ctrl.twitter"><a href="{{$ctrl.twitter}}"></a></li>
      <li class="socialMedia__youtube socialMedia__icon" ng-if="$ctrl.youtube"><a href="{{$ctrl.youtube}}"></a></li>
      <li class="socialMedia__pinterest socialMedia__icon" ng-if="$ctrl.pinterest"><a href="{{$ctrl.pinterest}}"></a></li>
      <li class="socialMedia__snapchat socialMedia__icon" ng-if="$ctrl.snapchat"><a href="{{$ctrl.snapchat}}"></a></li>
      <li class="socialMedia__linkedin socialMedia__icon" ng-if="$ctrl.linkedin"><a href="{{$ctrl.linkedin}}"></a></li>
    </ul>
  </div>
  `,
  bindings: {
    id: '@',
    text: '@',
    facebook: '@',
    instagram: '@',
    youtube: '@',
    twitter: '@',
    pinterest: '@',
    snapchat: '@',
    linkedin: '@',
  },
  controller() {
    this.$onInit = () => {
    };
  },
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/socialMedia/index.js